/* OBJECTS */
//import $ from 'jquery'
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"
import Swiper from 'swiper';
import {
  Navigation,
  //Pagination,
  // Autoplay
} from 'swiper/modules';
import { Virtual } from 'swiper/modules';
import 'swiper/css'

let slider;
export default class App {
  constructor() { }
  InitControls = () => {
    const $this = this;
    const games = document.querySelectorAll('.pac-open-game');
    if (games) {
      // Initialize card click
      document.addEventListener('click', function (e) {
        const card = e.target.closest('.pac-card');
        if (card) {
          e.preventDefault();
          card.classList.toggle('open');
        }
      });

      games.forEach(game => {
        game.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (game.classList.contains('loading')) {
            return;
          }
          const gameID = game.getAttribute('data-game-id');
          game.classList.add('loading');
          $this.OpenGame(gameID).then(() => {
            game.classList.remove('loading');
          });
        });
      });
    }
    // Close game window on key esc
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const gameWindow = document.getElementById('pac_game_window');
        gameWindow.classList.remove('open');
        setTimeout(() => {
          $this.CloseGame();
        }, 500);
      }
    });
  }

  ToastMessage(message, type = 'error', duration = 10000) {
    Toastify({
      duration: duration,
      text: message,
      className: type
    }).showToast();
  }

  OpenGame = async (gameID) => {
    const $this = this;
    if (!gameID) {
      alert('No game ID found');
      return;
    }
    var target = window.location.protocol + '//' + window.location.hostname + '/wp-admin/admin-ajax.php';
    var data = {
      game_id: gameID,
      method: 'get_game',
      action: 'cards_control'
    };

    try {
      const response = await fetch(target, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data),
      });
      const result = await response.json();
      if (result.success) {
        const game = result.data;
        if (game) {
          $this.RenderGame(game);
        }
      } else if (!result.success) {
        if (result.errors) {
          result.errors.forEach(error => {
            $this.ToastMessage(error, 'error');
          });
        } else {
          $this.ToastMessage('Nenumatyta klaida.', 'error');
        }
      }
    } catch (error) {
      $this.ToastMessage(error, 'error');
    }
  }

  CloseGame = () => {
    const $this = this;

    const closeButton = document.getElementById('pac-close-game');
    if (closeButton) {
      closeButton.removeEventListener('click', () => {

      });
    }
    if (slider) {
      slider.destroy();
    }
    const pac_card = document.querySelectorAll('.pac-card');
    if (pac_card) {
      pac_card.forEach(card => {
        card.removeEventListener('click', function () {

        });
      });
    }

    // const existingGameWindow = document.getElementById('pac_game_window');
    // if (existingGameWindow) {
    //   existingGameWindow.remove();
    // }
    const existingGameWindow = document.getElementById('pac_game_window');
    if (existingGameWindow) {
      existingGameWindow.classList.add('hidden');
      existingGameWindow.innerHTML = '';
    }

    document.body.classList.remove('pac_open');
  }

  RenderGame = (html) => {
    const $this = this;
    this.CloseGame();

    const wpadminbar = document.getElementById('wpadminbar');
    if (wpadminbar) {
      wpadminbar.style.zIndex = 9998;
    }

    document.body.classList.add('pac_open');

    let gameWindow = document.getElementById('pac_game_window');
    // if (!gameWindow) {
    //   gameWindow = document.createElement('div');
    //   gameWindow.id = 'pac_game_window';
    // }
    gameWindow.innerHTML = html;

    //document.body.appendChild(gameWindow);

    // Destroy slider if exists
    if (slider) {
      slider.destroy();
    }

    // Initialize slider
    slider = this.CardsSlider();

    // Initalize close button
    const closeButton = document.getElementById('pac-close-game');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        const gameWindow = document.getElementById('pac_game_window');
        gameWindow.classList.remove('open');
        setTimeout(() => {
          $this.CloseGame();
        }, 500);
      });
    }

    // Initialize card click
    // const pac_card = document.querySelectorAll('.pac-card');
    // if (pac_card) {
    //   pac_card.forEach(card => {
    //     card.addEventListener('click', function (e) {
    //       e.preventDefault();
    //       card.classList.toggle('open');
    //     });
    //   });
    // }

    // Unhide game window
    gameWindow.classList.remove('hidden');
    setTimeout(() => {
      gameWindow.classList.add('open');
    }, 100);
  }

  CardsSlider = () => {
    let slider = new Swiper('.pac-slider', {
      modules: [Navigation, Virtual],
      loop: false,
      preventClicks: false,
      preventClicksPropagation: false,
      lazy: true,
      preloadImages: false,
      passiveListeners: false,
      slidesPerView: 1,  // Adjust as needed
      spaceBetween: 10,  // Adjust as needed
      virtual: {
        enabled: true,
      },
      on: {
        afterInit: function () {
          const updateAnimations = (slide, add) => {
            if (!slide) {
              return;
            }
            const animatedElements = slide ? slide.querySelectorAll('[data-animation]') : [];
            animatedElements.forEach(element => {
              const animationClasses = element.getAttribute('data-animation').split(' ').filter(animationClass => animationClass.trim() !== '');
              animationClasses.forEach(animationClass => {
                element.classList.toggle('animate__animated', add);
                element.classList.toggle(animationClass, add);
                if (!add) {
                  element.classList.remove('animate__delay-1s');
                }
              });
            });
          };

          this.slides.forEach((slide, index) => {
            if (index !== this.activeIndex) {
              updateAnimations(slide, false);
            }
          });

          const activeSlide = this.slides[this.activeIndex];
          updateAnimations(activeSlide, true);

          // Sufleris
          const removeElements = activeSlide ? activeSlide.querySelectorAll('[data-fade-out-after]') : [];
          removeElements.forEach(element => {
            const delay = element.getAttribute('data-fade-out-after');
            setTimeout(() => {
              element.classList.remove('animate__animated', 'animate__backInUp');
              element.classList.add('animate__animated', 'animate__bounceOutDown');
              setTimeout(() => {
                element.remove();
              }, 2500);
            }, delay);
          });

          setTimeout(() => {
            const activeSlide = this.slides[this.activeIndex];
            const animatedElements = activeSlide ? activeSlide.querySelectorAll('[data-animation]') : [];
            animatedElements.forEach(element => {
              element.classList.remove('animate__delay-1s');
              const animationClasses = element.getAttribute('data-animation').split(' ').filter(animationClass => animationClass.trim() !== '' && animationClass !== 'animate__delay-1s');
              element.setAttribute('data-animation', animationClasses.join(' '));
            });
          }, 3000);
        },
        slideChange: function () {
          const updateAnimations = (slide, add) => {
            const animatedElements = slide.querySelectorAll('[data-animation]');
            animatedElements.forEach(element => {
              const animationClasses = element.getAttribute('data-animation').split(' ').filter(animationClass => animationClass.trim() !== '');
              animationClasses.forEach(animationClass => {
                element.classList.toggle('animate__animated', add);
                element.classList.toggle(animationClass, add);
              });
            });
          };

          this.slides.forEach((slide, index) => {
            updateAnimations(slide, index === this.activeIndex);
          });
        }
      },
      navigation: {
        nextEl: '.pac-swiper-button-next',
        prevEl: '.pac-swiper-button-prev'
      }
    })

    return slider;
  }

  init = () => {
    this.InitControls()
  }
}
